
    import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
    import AbpBase from '../../../lib/abpbase'

    // 表单数据模型
    interface FormData {
        id: number;
        planNumbersText: string; // 计划批次号文本域（一行一个）
        planNumbers: string[]; // 计划批次号数组
        userId: number; // 当前用户ID
    }

    @Component({ name: 'PackingPlanBaseForm' })
    export default class PackingPlanBaseForm extends AbpBase {
        @Prop({ type: Boolean, default: false }) value!: boolean;
        // 表单数据
        formData: FormData = {
            id: 0,
            planNumbersText: '',
            planNumbers: [],
            userId: this.$store.state.user.id || 0 // 当前登录用户ID
        };
        // 表单校验规则（仅校验计划批次号）
        formRules = {
            planNumbersText: [
                { required: true, message: '请输入计划批次号', trigger: 'blur' },
                { validator: this.validatePlanNumbers, trigger: 'blur' }
            ]
        };

        // 弹窗显隐变化
        visibleChange(val: boolean) {
            if (val) {
                this.initForm();
            } else {
                this.resetForm();
            }
        }

        // 初始化表单
        async initForm() {
            // 获取Vuex中的装箱模型
            const packingModel = this.$store.state.frontPackingBatch.packingModel;
            if (packingModel && packingModel.id) {
                // 编辑基础信息（仅回显计划批次号）
                this.formData.id = packingModel.id;
                // 转换计划批次号为文本域格式
                if (packingModel.inStockList && packingModel.inStockList.length) {
                    const planNumbers = [...new Set(packingModel.inStockList.map((item: any) => item.planNumber || ''))];
                    this.formData.planNumbersText = planNumbers.filter(Boolean).join('\n');
                }
            } else {
                // 新增状态：重置表单
                this.resetForm();
            }
        }

        // 重置表单
        resetForm() {
            this.formData = {
                id: 0,
                planNumbersText: '',
                planNumbers: [],
                userId: this.$store.state.user.id || 0
            };
            (this.$refs.packingPlanBaseForm as any).resetValidation();
        }

        // 校验计划批次号
        validatePlanNumbers(rule: any, value: string, callback: Function) {
            if (!value || value.trim() === '') {
                callback(new Error('计划批次号不能为空'));
                return;
            }
            const planNumbers = value.split('\n').map(item => item.trim()).filter(Boolean);
            if (planNumbers.length === 0) {
                callback(new Error('请输入有效的计划批次号'));
                return;
            }
            callback();
        }

        // 提交表单
        @Emit('save-success')
        async handleSubmit() {
            // 表单校验
            const formRef = this.$refs.packingPlanBaseForm as any;
            await formRef.validate();

            // 处理计划批次号
            this.formData.planNumbers = this.formData.planNumbersText
                .split('\n')
                .map(item => item.trim())
                .filter(Boolean)
                .filter((value, index, self) => self.indexOf(value) === index);

            // 构造提交参数（仅包含计划批次号、用户ID、ID）
            const submitData = {
                PlanNumbers: this.formData.planNumbers,
                UserId: this.formData.userId,
                Id: this.formData.id
            };

            // 调用对应接口（创建/保存基础信息复用CreatePack接口，后端兼容ID判断）
            await this.$store.dispatch({
                type: 'frontPackingBatch/createPack',
                data: submitData
            });

            this.$Message.success(this.formData.id ? '基础信息保存成功！' : '装箱计划创建成功！');
            this.$emit('save-success');
            this.handleCancel();
        }

        // 取消弹窗
        handleCancel() {
            this.$emit('input', false);
            this.resetForm();
        }
    }
